import { getOfficeConsent } from './GetOfficeConsent';
import { acceptAllOfficeConsents } from './AcceptAllOfficeConsents';
import { getOfficeConsentContent } from './GetOfficeConsentContent';
import { acceptOfficeConsentContent } from './AcceptOfficeConsentContent';
import { getPublicConsent } from './GetPublicConsent';

export const ConsentsClient = {
  getOfficeConsent,
  acceptAllOfficeConsents,
  getOfficeConsentContent,
  acceptOfficeConsentContent,
  getPublicConsent,
};
